// Update form
// Because of how the data is organised there are scenarios where we need to know if the data is nested or if it is contained in an array etc
// This function dispatches actions to update the vuex store on every form input
async function updateForm (input, e, nested=false, array=false, index='', item='') {
  // Check if at application stage or onboarding stage
  if (this.getRecruit.status !== 'offerLetterSent' && this.getRecruit.status !== 'onboardingInProgress') {
    // Check if input is nested and construct data object accordingly
    if (nested) {
      const data = {
        input: input.input,
        category: input.category,
        value: e
      }
      this.updateRecruitAction(data)
    } else {
      const data = {
        input,
        value: e
      }
      this.updateRecruitAction(data)
    }
    // Check if Belfast has been selected and update accordingly so extra section is displayed on ethnicity form
    if (this.getRecruit.centres.includes('Belfast')) {
      this.updateBelfastSelectedAction(true)
    } else {
      this.updateBelfastSelectedAction(false)
    }
  } else {
    // Some elements in this section will be contained in an array so we need to know if that is the case and update accordingly
    const data = {
      input,
      value: e,
      form: this.formName,
      array,
      index,
      item
    }
    this.updateOnboardingFormAction(data)
  }
}

// Postcode select
// We use this helper for both UK and Irish postcode finders
// As the data that gets returned is different between the two we need to be able to handle the different scenarios
function selectPostcode (address, addressOwner, isArray=false, index='', input, arrayName='') {
  const data = {
    address,
    postcode: this.postcodeLookup,
    formName: this.formName,
    addressOwner: addressOwner ? addressOwner : this.addressOwner,
    isArray,
    index,
    input,
    arrayName
  }
  this.selectAddressAction(data)
  this.postcodeResult = ''
}

export {
  updateForm,
  selectPostcode
}
